import React from 'react';

// ===  Helpers === //
import * as utils from '@utils';

// === Styles === //
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { breakpoints, colors, dimensions, respondTo } from '@styles';

const ListItem = styled.div`
  display: block;
  width: 220px;
  text-align: center;
  padding: 20px 10px 0;

  &.six-box {
    display: block;
    width: 155px;
    text-align: center;
    padding: 20px 10px 0;
    ${respondTo(
      breakpoints.md,
      css`
        width: 130px;
      `
    )}
  }
`;

const ListItemIcon = styled.img`
  display: block;
  margin: auto;
  width: 150px;
  border-radius: 50%;

  &.six-box {
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }
`;

const ListItemText = styled.div<ListItemTextProps>`
  text-align: center;
  color: ${(props) => (props.background === false ? colors.footerText : colors.white)};
  font-size: ${dimensions.fontSize.regular}px;
  margin: 0 auto;
  padding-top: 22px;
  word-break: break-word;

  &.six-box {
    padding-top: 0;
  }
`;

interface ListWithIconsItemProps {
  icon: string;
  text: string;
  className: string;
  background: boolean;
  alt?: string;
  title?: string;
}

interface ListItemTextProps {
  background: boolean;
}

const ListWithIconsItem = ({
  text,
  icon,
  className,
  background,
  alt = '',
  title = '',
}: ListWithIconsItemProps) => {
  return (
    <ListItem className={className}>
      {icon && icon !== '' && (
        <ListItemIcon src={icon} alt={alt} title={title} className={className} />
      )}
      <ListItemText background={background} className={className}>
        {utils.SafeHtml(text)}
      </ListItemText>
    </ListItem>
  );
};

export default ListWithIconsItem;
